<mh-box-score
  [value]="actualValue()"
  [type]="variationClass()"
  [type_number]="'percent'"
  [previous_value]="(variationValue() | formatPercent)"
  [previous]="('inter-chain.summary.table.previous_value' | translate:({score: previousValue()}))"
></mh-box-score>